import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { IDamageType, IDamageTypeProps, IDamageTypeStates } from "./interfaces";

export class DamageType extends EntityManager<IDamageType, IDamageTypeProps, IDamageTypeStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "DamageType",
            title: "نوع خسارت",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام نوع خسارت را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }],
                    showInLookup: false
                },
                {
                    title: "نیاز به انتقال مالکیت",
                    dataIndex: "PossessionTransition",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    filterable: true,
                    width: 200,
                    showInLookup: false
                }
            ]
        };
    }
}